import type { Dictionary } from '@/i18n/dictionary'
import { mediusTermsTr } from '@/i18n/medius-terms'
import { mediusDeletionTr, mediusPrivacyTr } from '@/i18n/medius-policies'
import { sparsaAcceptableUseTr, sparsaTermsTr } from '@/i18n/sparsa-terms'
import { sparsaDeletionTr, sparsaPrivacyTr } from '@/i18n/sparsa-policies'

export const tr: Dictionary = {
  meta: {
    home: {
      title: 'Dalmos Systems — Özel İş Yazılımları, CRM ve Entegrasyonlar',
      description:
        'Dalmos Systems; finans, gayrimenkul, konaklama ve lojistik için özel iş yazılımları geliştirir: CRM, ERP ve PMS entegrasyonları, bulut altyapısı ve uzun vadeli bakım.',
      keywords: [
        'özel iş yazılımı',
        'CRM uygulaması',
        'gayrimenkul yazılımı',
        'otel ve konaklama yazılımı',
        'ERP ve PMS entegrasyonları',
        'API entegrasyonları',
        'Microsoft Dynamics 365',
        'Power Platform',
        'Hırvatistan yazılım geliştirme',
      ],
    },
    privacy: {
      title: 'Gizlilik Politikası — Dalmos Systems',
      description:
        'Dalmos Systems’in iletişim formu aracılığıyla gönderilen kişisel verileri Genel Veri Koruma Tüzüğü (GDPR) uyarınca nasıl işlediği.',
    },
    legal: {
      title: 'Yasal bilgiler — Dalmos Systems',
      description:
        'Dalmos Systems’in yasal bilgileri: tescilli unvan, Šibenik’teki merkez, Hırvatistan Esnaf Sicili kaydı ve iletişim bilgileri.',
    },
    mediusPrivacy: {
      title: 'Medius gizlilik politikası — Dalmos Systems',
      description:
        'Medius by Dalmos Systems’in müşterileri adına e-posta, sohbet, WhatsApp, Messenger, Instagram ve aramalardan gelen kişisel verileri nasıl işlediği.',
    },
    mediusDeletion: {
      title: 'Medius veri silme — Dalmos Systems',
      description:
        'Facebook Messenger, Instagram ve WhatsApp üzerinden gelen mesajlar dahil, kişisel verilerinizin Medius’tan silinmesini nasıl talep edebileceğiniz.',
    },
    mediusTerms: {
      title: 'Medius kullanım koşulları — Dalmos Systems',
      description:
        'Dalmos Systems’in e-posta, sohbet, mesajlaşma ve aramalar için iletişim çalışma alanı Medius’u kurumsal müşterilerine sunduğu koşullar.',
    },
    sparsaPrivacy: {
      title: 'Sparsa gizlilik bildirimi — Dalmos Systems',
      description:
        'Sparsa by Dalmos’un bülten alıcılarının ve uygulama kullanıcılarının kişisel verilerini nasıl işlediği; açılma ve tıklamaları yalnızca rızayla ölçtüğü.',
    },
    sparsaDeletion: {
      title: 'Sparsa veri silme — Dalmos Systems',
      description:
        'Sparsa by Dalmos üzerinden gönderilen bültenleri nasıl durdurabileceğiniz ve kişisel verilerinizin silinmesini nasıl talep edebileceğiniz.',
    },
    sparsaTerms: {
      title: 'Sparsa kullanım koşulları — Dalmos Systems',
      description:
        'Dalmos Systems’in bülten hizmeti Sparsa by Dalmos’u işletmelere ve diğer kuruluşlara sunduğu koşullar.',
    },
    sparsaAcceptableUse: {
      title: 'Sparsa kabul edilebilir kullanım politikası — Dalmos Systems',
      description:
        'Sparsa by Dalmos ile gönderim kuralları: her alıcı için rıza, satın alınmış veya toplanmış liste yok, içe aktarma beyanları ve kötüye kullanımın bildirilmesi.',
    },
    notFound: {
      title: 'Sayfa bulunamadı — Dalmos Systems',
      description: 'İstediğiniz sayfayı bulamadık.',
    },
  },
  nav: {
    home: 'Ana sayfa',
    services: 'Hizmetler',
    about: 'Hakkımızda',
    contact: 'İletişim',
    cta: 'Teklif isteyin',
    openMenu: 'Menüyü aç',
    closeMenu: 'Menüyü kapat',
    languageLabel: 'Dil seçin',
    currentLanguage: 'Geçerli dil',
  },
  a11y: {
    skipToContent: 'İçeriğe geç',
    decorative: 'Dekoratif öğe',
  },
  hero: {
    eyebrow: 'İşletmeler için özel yazılım çözümleri',
    headlineBefore: 'İşletmeniz için çalışan sistemler,',
    headlineAccent: 'siz onlar için değil.',
    subtitle:
      'Özel iş yazılımlarında teknik ortağınız: büyük CRM projelerinden gelen deneyimle finans, gayrimenkul, konaklama ve lojistik için çözümler. Microsoft ekosistemi tek odak değil, güvenilir bir temeldir.',
    ctaPrimary: 'Teklif isteyin',
    ctaSecondary: 'Hizmetleri görün',
    chips: [
      'CRM ve ERP entegrasyonları',
      'Konaklama ve PMS',
      'Finansal çözümler',
      'Gayrimenkul',
      'Mobil uygulamalar',
      'Depo ve tesis yönetimi',
    ],
    scrollHint: 'Kaydırın',
  },
  stats: {
    title: 'Neye dayanıyoruz',
    items: [
      { value: '20+', label: 'Tek çatı altında hizmet alanı' },
      { value: '6', label: 'Kanıtlanmış çözüm kalıplarına sahip sektör' },
      { value: '1', label: 'Projeyi yöneten ve kodu yazan kişi' },
      { value: '%100', label: 'Projelerin tanımlı destekle teslim edilme oranı' },
    ],
  },
  why: {
    title: 'Neden Dalmos Systems',
    cards: [
      {
        title: 'Doğrudan erişim',
        body: 'Ajans katmanları yok: projeyi geliştiren kişiyle doğrudan konuşursunuz.',
      },
      {
        title: 'Sektöre göre şekillenen çözümler',
        body: 'Finans ve gayrimenkulden konaklama ve lojistiğe kadar her sistem, gerçek süreçleriniz etrafında kurulur.',
      },
      {
        title: 'Yüklenici değil, iş ortağı',
        body: 'Teslimattan sonra da sistemin yanındayız: bakım, güncellemeler ve destek anlaşmanın bir parçasıdır.',
      },
    ],
  },
  services: {
    title: 'Geniş çözüm yelpazesi, tek kaynak',
    lede: 'Finans ve gayrimenkulden konaklama ve bulut altyapısına kadar her hizmet, tek bir dar alana sıkışmadan, uygulama ve uzun vadeli bakımla birlikte gelir.',
    items: {
      crm: {
        title: 'CRM ve özelleştirme',
        body: 'CRM sistemlerinin süreçlerinize, ekiplerinize ve müşterilerinize göre kurulması ve uyarlanması.',
      },
      erp: {
        title: 'ERP sistemleri ve entegrasyonlar',
        body: 'ERP’nin satış, depo ve finansla bağlanması ve mevcut modüllerin uyarlanması.',
      },
      processes: {
        title: 'Süreç otomasyonu ve optimizasyonu',
        body: 'Kararları hızlandıran ve el ile yapılan işi azaltan uygulamalarla iç iş akışlarının otomasyonu.',
      },
      finance: {
        title: 'Finansal çözümler',
        body: 'Maliyet takibi, faturalama ve finansal raporlama sistemleri.',
      },
      realEstate: {
        title: 'Gayrimenkul ve varlık yönetimi',
        body: 'Mülk portföylerinin, kira sözleşmelerinin ve değerlemelerin yönetimi.',
      },
      mobile: {
        title: 'Mobil uygulamalar',
        body: 'Saha, depo veya satış ekipleri için iş sistemlerinin mobil uzantıları.',
      },
      hospitality: {
        title: 'Konaklama çözümleri',
        body: 'Oteller, restoranlar ve konaklama işletmeleri için sistemler: PMS entegrasyonları, rezervasyonlar, misafir verileri ve operasyonlar.',
      },
      web: {
        title: 'Web çözümleri ve portallar',
        body: 'İş sisteminizle uyumlu web siteleri.',
      },
      reservations: {
        title: 'Rezervasyon sistemleri',
        body: 'PMS’inize ve faturalamanıza bağlı, gerçek zamanlı çevrim içi rezervasyonlar.',
      },
      analytics: {
        title: 'İstatistik ve raporlama',
        body: 'Gerçek verilere dayanan kararlar için gösterge panoları.',
      },
      loyalty: {
        title: 'Sadakat sistemleri',
        body: 'Puan, seviye ve ödüllerle sadakat programları, üye kartları ve mobil uygulama ya da dijital cüzdan kartı. Teklifler ve kampanyalar her üyenin satın alma geçmişine göre şekillenir ve her şey CRM’inize bağlı kalır.',
      },
      marketing: {
        title: 'Pazarlama ve bültenler',
        body: 'CRM’inizdeki kitleye bültenler ve kampanyalar; rıza yönetimi ve abonelikten çıkma yerleşik olarak gelir.',
      },
      communication: {
        title: 'İletişim çözümleri',
        body: 'Ekibinizin müşterilerle iletişimi için, CRM’inize bağlı ya da bağımsız çalışan özel çözümler.',
      },
      warehouse: {
        title: 'Depo yönetimi',
        body: 'Stok seviyelerinin ve mal hareketlerinin takibi.',
      },
      facility: {
        title: 'Tesis yönetimi',
        body: 'Tesislerin ve bakım işlerinin yönetimi.',
      },
      api: {
        title: 'API entegrasyonları ve ara katman yazılımı',
        body: 'Birbiriyle konuşmayan CRM, ERP, PMS ve diğer sistemlerin birbirine bağlanması.',
      },
      cloud: {
        title: 'Bulut altyapısı ve DevOps',
        body: 'Azure ortamları, CI/CD ve otomasyon.',
      },
      microsoft: {
        title: 'Microsoft ekosistemi',
        body: 'İşletme için doğru seçenek olduklarında Dynamics 365, Power Platform ve Azure.',
      },
      security: {
        title: 'BT güvenliği ve uyumluluk',
        body: 'Veri koruma ve GDPR uyumluluğu.',
      },
      custom: {
        title: 'Özel yazılım çözümleri',
        body: 'Belirli ihtiyaçlar için size özel çözümler.',
      },
      training: {
        title: 'Eğitim ve kullanıma geçiş',
        body: 'Kullanıcı eğitimi ve kurum içi dokümantasyon.',
      },
      support: {
        title: 'Destek ve SLA anlaşmaları',
        body: 'Tanımlı yanıt ve destek süreleri.',
      },
    },
  },
  integrations: {
    title: 'Sonunda birbiriyle konuşan sistemler',
    lede: 'CRM, ERP ve PMS nadiren kendiliğinden birbirine bağlanır. Biz bağlarız: veri bir kez girilir ve her yerde görünür. Yeniden yazmak yok, arada elektronik tablolar yok.',
    hubLabel: 'Tek doğruluk kaynağı',
    systems: [
      {
        code: 'CRM',
        title: 'Müşteriler ve satış',
        body: 'Müşteriler, fırsatlar ve iletişim tek bir yerde; teklifler, sözleşmeler ve faturalamayla senkronize.',
      },
      {
        code: 'ERP',
        title: 'Finans ve operasyonlar',
        body: 'Faturalama, satın alma ve stok; satışa ve depoya bağlı, çift veri girişi olmadan.',
      },
      {
        code: 'PMS',
        title: 'Konaklama',
        body: 'Rezervasyonlara, CRM’e ve muhasebeye bağlı tesis yönetim sistemleri.',
      },
      {
        code: 'API',
        title: 'Diğer her şey',
        body: 'Muhasebe, e-ticaret, POS, kanal yöneticileri, BI araçları ve kurum içi uygulamalar.',
      },
    ],
    capabilitiesTitle: 'Neler elde edersiniz',
    capabilities: [
      'Çift yönlü, gerçek zamanlı veri senkronizasyonu',
      'Kesintisiz veri taşıma',
      'Özel ara katman yazılımı ve API’ler',
      'Bir şey bozulduğunda izleme, kayıtlar ve uyarılar',
    ],
  },
  about: {
    title: 'Hakkımızda',
    statementBefore: 'Yeni bir şirket.',
    statementAccent: 'Sıfırdan başlamayan bir deneyim.',
    lede: 'Dalmos Systems, özel iş yazılımlarında teknik bir ortak olarak kuruldu: finans, gayrimenkul, konaklama, lojistik ve daha fazlası. Yaklaşımımız, gayrimenkul ve konaklama sektörlerindeki büyük CRM taşıma ve entegrasyon projelerindeki çalışmaların doğrudan devamıdır; arada büyük bir organizasyon olmadan.',
    processTitle: 'Nasıl çalışıyoruz',
    steps: [
      {
        index: '01',
        title: 'Keşif',
        body: 'İlk kod satırından önce süreci anlamak.',
      },
      {
        index: '02',
        title: 'Çözüm tasarımı',
        body: 'Mimari sistemlerinize uyarlanır, sistemleriniz mimariye değil.',
      },
      {
        index: '03',
        title: 'Uygulama',
        body: 'Sizinle düzenli görüşmelerle adım adım teslimat.',
      },
      { index: '04', title: 'Destek', body: 'Canlıya geçişten sonra da sistemin yanındayız.' },
    ],
    valuesTitle: 'Bize yol gösteren ilkeler',
    values: [
      {
        title: 'Doğrudan erişim',
        body: 'Projeyi yöneten kişi, konuştuğunuz kişidir; arada iletişim katmanları yoktur.',
      },
      {
        title: 'Şeffaflık',
        body: 'İlk kod satırından önce net kapsam, net fiyat ve net proje sınırları.',
      },
      {
        title: 'Uzun ömürlü yapılar',
        body: 'Bırakıp gideceğimiz projeler değil, bakımını kendimiz üstleneceğimiz sistemler kurarız.',
      },
    ],
  },
  contact: {
    title: 'Sisteminizi konuşalım',
    lede: 'Projenizi kısaca anlatarak bize yazın; bir sonraki adım için bir öneriyle size dönelim.',
    responseNote: '{days} iş günü içinde yanıt veririz.',
    emailLabel: 'E-posta',
    phoneLabel: 'Telefon',
    form: {
      name: 'Ad soyad',
      namePlaceholder: 'Ayşe Yılmaz',
      email: 'E-posta',
      emailPlaceholder: 'ayse@sirket.com',
      company: 'Şirket',
      companyPlaceholder: 'Şirket adı (isteğe bağlı)',
      message: 'Mesaj',
      messagePlaceholder:
        'Projeyi, kullandığınız sistemleri ve hedeflediğiniz zaman planını anlatın.',
      consent: 'Verilerimin bu talebi yanıtlamak için kullanılmasını kabul ediyorum.',
      submit: 'Talebi gönder',
      submitting: 'Gönderiliyor…',
      successTitle: 'Talebiniz gönderildi.',
      successBody: 'Belirttiğiniz e-posta adresinden size dönüş yapacağız.',
      errorTitle: 'Gönderim başarısız oldu.',
      errorBody: 'Lütfen tekrar deneyin ya da bize doğrudan e-postayla yazın.',
      fallbackHint: 'E-posta uygulamanızı açın',
      errors: {
        nameRequired: 'Lütfen adınızı ve soyadınızı girin.',
        emailRequired: 'Lütfen e-posta adresinizi girin.',
        emailInvalid: 'Bu e-posta adresi geçerli değil.',
        messageRequired: 'Lütfen bir mesaj yazın.',
        messageTooShort: 'Mesaj en az 20 karakter uzunluğunda olmalıdır.',
        consentRequired: 'Verilerin işlenmesine onay vermeniz gerekir.',
      },
    },
  },
  footer: {
    tagline: 'Finans, gayrimenkul, konaklama ve lojistik için özel iş yazılımları.',
    navTitle: 'Gezinme',
    legalTitle: 'Yasal',
    privacy: 'Gizlilik politikası',
    legalNotice: 'Yasal bilgiler',
    rights: 'Tüm hakları saklıdır.',
    builtIn: 'Ulica Sedmog kontinenta 1, 22000 Šibenik, Hırvatistan',
  },
  privacy: {
    title: 'Gizlilik politikası',
    lastUpdatedLabel: 'Son güncelleme',
    lastUpdated: '2026-10-31',
    intro:
      'Bu politika, Dalmos Systems’in bu web sitesi aracılığıyla bize gönderdiğiniz kişisel verileri nasıl işlediğini açıklar.',
    sections: [
      {
        heading: 'Veri sorumlusu',
        paragraphs: [
          'Veri sorumlusu {controller} unvanlı işletmedir. Veri işlemeyle ilgili tüm sorularınız için {email} adresine yazabilirsiniz.',
        ],
      },
      {
        heading: 'Hangi verileri topluyoruz',
        paragraphs: [
          'İletişim formu aracılığıyla adınızı, e-posta adresinizi, belirtirseniz şirketinizin adını ve mesajınızın içeriğini topluyoruz.',
          'Reklam çerezleri veya ziyaretçileri başka web sitelerinde izleyen araçlar kullanmıyoruz.',
          'Ziyaretleri, Cloudflare’in çerez kullanmayan betiği Cloudflare Web Analytics (static.cloudflareinsights.com) ile sayıyoruz. Bir sayfa yüklendiğinde betik Cloudflare’e anonim sayfa görüntüleme ve performans verileri gönderir: sayfanın adresi, geldiğiniz sayfa ve yüklenme süreleri ile sayfanın nasıl çalıştığına ilişkin benzer ölçümler; Cloudflare buna istekten tarayıcıyı, işletim sistemini, cihaz türünü ve ülkeyi ekler. Betik çerez yerleştirmez, cihazınızda başka bir depolama alanı kullanmaz ve ziyaretçi tanımlayıcısı oluşturmaz. IP adresiniz, her web sitesinde olduğu gibi istekle birlikte Cloudflare’e ulaşır; Cloudflare bunu sizi tanımlamak için kullanmaz ve bu amaçla saklamaz. Biz yalnızca sayfa görüntülemeleri, yönlendiren siteler, ülkeler ve cihaz türleri gibi toplamları görürüz ve bunları web sitesinin nasıl kullanıldığını anlamak ve sitenin hızlı kalmasını sağlamak için kullanırız. Hukuki dayanağımız, web sitesini işletme ve geliştirme konusundaki meşru menfaatimizdir (GDPR madde 6(1)(f)). Cloudflare verileri bizim adımıza, veri işleyenimiz olarak, AB dışına aktarımlar için AB standart sözleşme hükümlerini içeren veri işleme eki kapsamında işler. Tam verileri 7 gün, ardından yaklaşık onda birlik bir örneğini saklar; bu örnekten son altı ayın istatistiklerini görürüz. Betiği tarayıcınızın ayarlarıyla veya bir içerik engelleyiciyle engelleyebilirsiniz; web sitesi onsuz da aynı şekilde çalışır. Aynısı, bu politikaya bağlantı veren Medius web sitesi medius.dalmossystems.com için de geçerlidir.',
        ],
      },
      {
        heading: 'Amaç ve hukuki dayanak',
        paragraphs: [
          'Verileri yalnızca talebinizi yanıtlamak ve teklif hazırlamak için kullanırız. Hukuki dayanak, rızanız ile potansiyel müşterilerle iletişim kurma konusundaki meşru menfaatimizdir.',
        ],
      },
      {
        heading: 'Saklama süresi',
        paragraphs: [
          'Talepleri son yazışmadan itibaren en fazla yirmi dört ay saklarız; bu sürenin sonunda, sözleşmeden veya kanundan doğan bir yükümlülük daha uzun saklamayı gerektirmedikçe silinirler.',
        ],
      },
      {
        heading: 'Haklarınız',
        paragraphs: [
          'Verilerinize erişme, bunları düzeltme, silme, işlemeyi kısıtlama, veri taşınabilirliği haklarına sahipsiniz ve rızanızı istediğiniz zaman geri çekebilirsiniz.',
          'Denetim makamı olarak Hırvatistan Kişisel Verilerin Korunması Ajansı’na (AZOP) şikâyette bulunabilirsiniz.',
        ],
      },
      {
        heading: 'Güvenlik ve veri aktarımı',
        paragraphs: [
          'Tarayıcınız ile sunucularımız arasındaki trafik şifrelenir. Verilerinizi satmayız ve siteyi işletmemize ve sizinle iletişim kurmamıza yardımcı olan, veri işleme sözleşmesiyle bağlı hizmet sağlayıcılar dışında üçüncü taraflarla paylaşmayız.',
        ],
      },
    ],
    backHome: 'Ana sayfaya dön',
  },
  legal: {
    title: 'Yasal bilgiler',
    intro: 'Hırvatistan Elektronik Ticaret Kanunu uyarınca hizmet sağlayıcıya ilişkin bilgiler.',
    nameLabel: 'Tescilli unvan',
    shortNameLabel: 'Kısa unvan',
    seatLabel: 'Kayıtlı merkez',
    country: 'Hırvatistan',
    registerLabel: 'Sicil',
    registerValue: 'Hırvatistan Esnaf Sicili (Obrtni registar), Šibenik-Knin İli',
    mboLabel: 'Sicil numarası (MBO)',
    registeredOnLabel: 'Tescil tarihi',
    activityLabel: 'Ana faaliyet',
    activityValue:
      'Bilgisayar programlarının ve uygulamalarının müşteri siparişine göre tasarımı, geliştirilmesi ve bakımı (NKD 2025: 62.10.9)',
    contactLabel: 'İletişim',
    backHome: 'Ana sayfaya dön',
  },
  mediusPrivacy: mediusPrivacyTr,
  mediusDeletion: mediusDeletionTr,
  mediusTerms: mediusTermsTr,
  mediusLinks: {
    mediusPrivacy: 'Medius gizlilik politikası',
    mediusDeletion: 'Verilerinizin silinmesini nasıl talep edersiniz',
    mediusTerms: 'Medius kullanım koşulları',
  },
  sparsaPrivacy: sparsaPrivacyTr,
  sparsaDeletion: sparsaDeletionTr,
  sparsaTerms: sparsaTermsTr,
  sparsaAcceptableUse: sparsaAcceptableUseTr,
  sparsaLinks: {
    sparsaPrivacy: 'Sparsa gizlilik bildirimi',
    sparsaDeletion: 'Bültenleri durdurma ve verilerinizi silme',
    sparsaTerms: 'Sparsa kullanım koşulları',
    sparsaAcceptableUse: 'Sparsa kabul edilebilir kullanım politikası',
  },
  notFound: {
    code: '404',
    title: 'Sayfa bulunamadı',
    body: 'Açtığınız adres mevcut değil ya da taşınmış.',
    cta: 'Ana sayfaya dön',
  },
}
